export default __webpack_public_path__ + "static/media/kidney-red.e5f3d16f.svg";